import {axiosConsumerAppInstance} from "~/api/ConsumerApiManager";
import {AxiosResponse} from "axios";
import {
  AddressDetails,
  EmailCommunicationDetails,
  PhoneCommunicationDetails,
} from "@bounce/shared/consumer/declarations";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";

type Variables = {
  contact: EmailCommunicationDetails | PhoneCommunicationDetails | AddressDetails;
  contactType: "email" | "phone" | "address";
};

export const addContactToUser = async (variables: Variables): Promise<any> => {
  const result = await axiosConsumerAppInstance.post<string, AxiosResponse<string>>(
    `/user/add_${variables.contactType}`,
    variables.contact
  );
  return result.data;
};

export const useAddContactToUser = (
  options?: BaseMutationOptions<boolean, Variables>
): BaseUseMutationResult<boolean, Variables> =>
  useBaseMutation(addContactToUser, {
    ...options,
    invalidateQueriesKeyFn: () => ["user"],
  });
